import {
  getDeduplicationKey,
  parseLowestPackagePriceUsd,
} from "./searchRelevance";
import { isHotelCardPriceDebugVerbose } from "./hotelSearchDebugFlags";

/**
 * Compare final list rows to raw API snapshot (same dedup key) — detects wrong winner after dedup/mapping.
 */
export function logHotelCardPriceDebug(finalHotels, rawSnapshotRows, meta = {}) {
  if (!Array.isArray(finalHotels) || !Array.isArray(rawSnapshotRows)) return;
  const verbose = isHotelCardPriceDebugVerbose();
  const rawByKey = new Map();
  for (const row of rawSnapshotRows) {
    if (!row || typeof row !== "object") continue;
    const key = getDeduplicationKey(row);
    if (!key) continue;
    if (!rawByKey.has(key)) rawByKey.set(key, []);
    rawByKey.get(key).push(row);
  }

  let mismatchCount = 0;
  const mismatches = [];

  for (const h of finalHotels) {
    if (!h || typeof h !== "object") continue;
    const key = getDeduplicationKey(h);
    const group = rawByKey.get(key) || [h];
    const prices = group
      .map((r) => parseLowestPackagePriceUsd(r?.LowestPackagePrice))
      .filter((n) => n != null);
    const minP = prices.length ? Math.min(...prices) : null;
    const displayed = parseLowestPackagePriceUsd(h?.LowestPackagePrice);
    const hotelId = h?.ID ?? h?.Id ?? "";
    const hotelName = String(h?.DisplayName || h?.Name || "").trim();

    let match = "unknown";
    if (minP != null && displayed != null) {
      match = Math.abs(minP - displayed) < 0.005 ? "ok" : "MISMATCH";
    } else if (minP == null && displayed == null) {
      match = "no_price";
    }

    if (match === "MISMATCH") {
      mismatchCount += 1;
      if (mismatches.length < 50) {
        mismatches.push({
          hotelId,
          hotelName,
          dedupKey: key,
          rawPricesConsidered: prices,
          cheapestCandidateUsd: minP,
          displayedUsd: displayed,
        });
      }
    }

    if (verbose) {
      console.info("[HOTEL_CARD_PRICE_DEBUG]", {
        hotelId,
        hotelName,
        dedupKey: key,
        rawPricesConsidered: prices,
        cheapestCandidateUsd: minP,
        displayedUsd: displayed,
        reasonSelected:
          match === "ok"
            ? "displayed_matches_min_among_raw_rows_same_dedup_key"
            : match === "MISMATCH"
              ? "displayed_differs_from_min_raw_same_dedup_key"
              : match === "no_price"
                ? "no_finite_prices_in_group"
                : "partial_price_data",
        ...meta,
      });
    }
  }

  console.info("[HOTEL_CARD_PRICE_DEBUG] summary", {
    totalFinalHotels: finalHotels.length,
    mismatchCount,
    ...meta,
  });
  if (mismatches.length) {
    console.warn("[HOTEL_CARD_PRICE_DEBUG] mismatches(sample)", mismatches);
  }
}
